<!--
  landing.component.html
  ----------------------
  Page 1 — Welcome screen shown after successful Entra ID login.

  Layout:
    ┌─────────────────────────────────────┐
    │  [Header — logo + app name]         │
    ├─────────────────────────────────────┤
    │                                     │
    │   Welcome, <Name>                   │
    │   Subtitle text                     │
    │                                     │
    │  [New Assessment] [Update Existing] │
    │                                     │
    └─────────────────────────────────────┘
  Note: No stepper nav bar on this page.
-->
<div class="landing">

  <!-- Welcome message -->
  <div class="landing__welcome">
    <h1 class="landing__greeting">
      Welcome{{ userName ? ', ' + userName : '' }}
    </h1>
    <p class="landing__subtitle">
      Select an option below to begin or continue a guardrail assessment.
    </p>
  </div>

  <!-- Action cards -->
  <div class="landing__actions">

    <!-- New Assessment card -->
    <button class="landing__card landing__card--new" (click)="startNewAssessment()">
      <div class="landing__card-icon" aria-hidden="true">&#43;</div>
      <div class="landing__card-body">
        <h2 class="landing__card-title">New Assessment</h2>
        <p class="landing__card-desc">
          Upload application artifacts and run a full guardrail assessment.
        </p>
      </div>
    </button>

    <!-- Existing Assessment card -->
    <button class="landing__card landing__card--existing" (click)="startExistingAssessment()">
      <div class="landing__card-icon" aria-hidden="true">&#8635;</div>
      <div class="landing__card-body">
        <h2 class="landing__card-title">Update Existing Assessment</h2>
        <p class="landing__card-desc">
          Retrieve a previous report and re-run selected guardrails with new artifacts.
        </p>
      </div>
    </button>

  </div>

</div>
